export default __webpack_public_path__ + "static/media/295.8e3f995b.png";